var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderPapersDownArrow = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 56",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.027 1.578l15.669 4.198 5.186 9.498-6.403 23.898-22.883-6.131 8.43-31.463z",
    fill: "#fff",
    stroke: "#B29A43",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7 15.023a.5.5 0 00.563-.733l-4.377-7.58a.5.5 0 00-.916.12l-1.731 6.461 6.461 1.732z",
    fill: "#B29A43",
    stroke: "#B29A43",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.752 9.682l15.67-4.198 9.24 5.632 6.403 23.898-22.883 6.131-8.43-31.463z",
    fill: "#fff",
    stroke: "#B29A43",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.512 11.49a.5.5 0 00.12-.916l-7.58-4.376a.5.5 0 00-.733.562l1.732 6.462 6.461-1.732z",
    fill: "#B29A43",
    stroke: "#B29A43",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.649 23.786H28.642c-1.36 0-2.66-.562-3.592-1.551l-3.123-3.315a4.936 4.936 0 00-3.592-1.55H5.351c-2.55 0-4.534 2.205-4.534 4.812v28.871c0 2.707 1.984 4.812 4.534 4.812H44.65c2.456 0 4.534-2.105 4.534-4.812V28.598c0-2.607-2.078-4.812-4.534-4.812z",
    fill: "#194BB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.494 33.163v11.594M30.429 40.072l-4.936 4.936-4.935-4.936",
    stroke: "#fff",
    strokeWidth: 2
  })));
};
export default SvgFolderPapersDownArrow;